import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const scrollPositions = {};

const ScrollToTopOnRouteChange = () => {
  const { pathname, key } = useLocation();
  const navType = useNavigationType();
  const prevKey = useRef(key);

  useEffect(() => {
    const saveScroll = () => {
      scrollPositions[prevKey.current] = window.scrollY;
    };

    window.addEventListener("beforeunload", saveScroll);
    return () => {
      saveScroll();
      window.removeEventListener("beforeunload", saveScroll);
    };
  }, []);

  useEffect(() => {
    if (prevKey.current !== key) {
      scrollPositions[prevKey.current] = window.scrollY;
      prevKey.current = key;
    }

    if (navType === "POP") {
      const saved = scrollPositions[key];
      if (saved != null) {
        requestAnimationFrame(() => {
          window.scrollTo(0, saved);
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, key, navType]);

  return null;
};

export default ScrollToTopOnRouteChange;
